export default __webpack_public_path__ + "static/media/logo-ae-pottery-barn-kids.af7bb20d.svg";